import { Project, SatelliteFlight } from "@nova/protobuf"
import {
    booleanValidator,
    boundingBoxValidators,
    createLayerValidator,
    enumValidator,
    parentIdValidators,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"
import { SATELLITE_TEMPORAL_BIAS_VALUES, SatelliteSensorType } from "@nova/constants"

export const createSatelliteFlightValidator = createLayerValidator(SatelliteFlight, {
    region: {
        validators: boundingBoxValidators,
        nonNull: true,
    },
    sensorType: {
        validators: enumValidator("sensorType", SatelliteSensorType),
        nonNull: true,
    },
    temporalAnchor: {
        validators: [
            {
                validator: (temporalAnchor) => temporalAnchor >= 0,
                error: "temporal anchor must be a valid date",
            },
        ],
    },
    cloudFree: {
        validators: booleanValidator("cloudFree must be a boolean value"),
    },
    dehaze: {
        validators: booleanValidator("dehaze must be a boolean value"),
    },
    temporalBias: {
        validators: [
            {
                validator: (value) =>
                    (SATELLITE_TEMPORAL_BIAS_VALUES as readonly string[]).includes(value),
                error: "temporalBias must be one of: " + SATELLITE_TEMPORAL_BIAS_VALUES.join(", "),
            },
        ],
        nonNull: true,
    },
    parentId: {
        validators: parentIdValidators,
    },
})

export const updateSatelliteFlightValidator = updateLayerValidator(SatelliteFlight, {
    // Unlike in createSatelliteFlightValidator, these pick which existing mosaic to display.
    cloudFree: {
        validators: booleanValidator("cloudFree must be a boolean value"),
    },
    dehaze: {
        validators: booleanValidator("dehaze must be a boolean value"),
    },
})

export const getDefaultSatelliteFlightCreateArgs = (
    project: Project,
    inParentId?: string,
    // Distinct per sibling so simultaneously-created flights still get correctly-ordered indices even against a stale project snapshot.
    steps = 0
) => ({
    visible: true,
    createdAt: dateAsNumber(),
    index: createNewLayerFractionalIndex(project, steps, inParentId),
    cloudFree: true,
    mosaic: [],

    // Overwritten by the caller's validated data afterward, not actually set here.
    parentId: undefined,
})

export type CreateSatelliteFlightArgs = UnionToTuple<keyof typeof createSatelliteFlightValidator>
export type UpdateSatelliteFlightArgs = UnionToTuple<keyof typeof updateSatelliteFlightValidator>
